export default __webpack_public_path__ + "static/media/new_logo.f5228473.svg";